export default "__VITE_ASSET__CFAhfn$4__"